export default {
  inject: {
    userAttribute: {
      default: () => ({}),
    },
    artistAndTitle: {
      default: () => ({}),
    },
  },
  data() {
    return {
      apiEndpoint: location.origin + '/api',
    };
  },
  created() {
    if (location.origin === 'http://localhost:8080') {
      this.apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
    }
  },
  methods: {
    $writeAccessLog: async function (scope = '') {
      if (!(await this.$getToken())) {
        return;
      }
      try {
        //パラメーター変数名
        const loc = document.location;
        const params = {
          href: loc.href,
          pathname: loc.pathname,
          query: loc.search,
          hash: loc.hash,
          referrer: document.referrer,
          artist: scope ? (scope === 'source' || scope === 'target' ? this.artistAndTitle[scope].artistObj.artist_name : scope) : '',
          w: window.screen.width,
          h: window.screen.height,
        };
        this.$fetchPost('/common/access-log-write', JSON.stringify(params));
      } catch (e) {
        console.error(e);
      }
    },

    //////////////////
    // fetch
    //////////////////

    async _errorHandler(response) {
      const responseStatus = Number(response.status);
      console.warn('fetch, errorHandler, response.status: ' + responseStatus);

      let jsonResponse;
      try {
        jsonResponse = await response.clone().json();
      } catch (e) {
        console.error('Response is not JSON:', e);
        jsonResponse = { message: '不明なエラーが発生しました' };
      }
      const errorMessage = jsonResponse.message || `code: ${responseStatus}`;

      switch (responseStatus) {
        case 401:
          if (jsonResponse.is_password_expired) {
            this.userAttribute.isPasswordExpired = true;
          } else {
            // 401エラーの場合、トークンリフレッシュを試行してからエラーハンドリング
            throw new Error('TOKEN_REFRESH_REQUIRED');
          }
          break;
        case 403:
          if (location.pathname === '/') this.$logout();
          else this.$router.push('/');
          break;
        default:
          if (responseStatus >= 500 && responseStatus < 600) {
            alert('サーバーでエラーが発生しました。' + errorMessage);
          } else if (responseStatus === 400) {
            alert('リクエストエラーが発生しました。' + errorMessage);
          } else {
            alert('エラーが発生しました。' + errorMessage);
          }
          break;
      }
    },

    async _handleResponse(response) {
      if (response.ok) {
        const responseBody = await response.text();
        try {
          return JSON.parse(responseBody);
        } catch (error) {
          return responseBody;
        }
      }
      await this._errorHandler(response);
      throw new Error(response.status);
    },

    _flattenObject(ob, prefix = '') {
      let result = {};
      for (const i in ob) {
        if (typeof ob[i] === 'object' && ob[i] !== null) {
          Object.assign(result, this._flattenObject(ob[i], prefix + i + '.'));
        } else {
          result[prefix + i] = ob[i];
        }
      }
      return result;
    },

    // 共通のエラーハンドリングメソッドを追加
    async _handleTokenRefreshError(error, isRetry, retryCallback) {
      // トークンリフレッシュが必要で、まだリトライしていない場合
      if (error.message === 'TOKEN_REFRESH_REQUIRED' && !isRetry) {
        console.log('Token refresh required, attempting refresh...');
        try {
          const refreshSuccess = await this.refreshToken();
          if (refreshSuccess) {
            console.log('Token refreshed successfully, retrying request...');
            return await retryCallback(); // リトライコールバック関数を実行
          }
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
        }
        // リフレッシュに失敗した場合は元のエラーメッセージを表示
        alert('認証の有効期限が切れました。ページをリロードして下さい。');
      }
      console.error(error);
      throw error;
    },

    async $fetch(api, query = {}, contentType = 'application/json', isRetry = false) {
      try {
        let urlQuery = this.userAttribute.authProvider === 'azuread' ? api : api + '-c';
        const loc = document.location;
        const baseQuery = {
          href: loc.href,
          pathname: loc.pathname,
          query: loc.search,
          hash: loc.hash,
          referrer: document.referrer,
        };
        const flattenedQuery = this._flattenObject(query);
        urlQuery += '?' + new URLSearchParams(Object.assign({}, baseQuery, flattenedQuery));

        const response = await fetch(this.apiEndpoint + urlQuery, {
          method: 'GET',
          cache: 'no-cache',
          headers: {
            'Content-Type': contentType,
            Authorization: 'Bearer ' + this.userAttribute.jwtToken,
          },
        });
        return await this._handleResponse(response);
      } catch (error) {
        return await this._handleTokenRefreshError(error, isRetry, () => this.$fetch(api, query, contentType, true));
      }
    },

    async $fetchDelete(api, query = {}, isRetry = false) {
      let urlQuery = this.userAttribute.authProvider === 'azuread' ? api : api + '-c';
      if (Object.keys(query).length) {
        urlQuery += '?' + new URLSearchParams(query);
      }

      try {
        const response = await fetch(this.apiEndpoint + urlQuery, {
          method: 'DELETE',
          cache: 'no-cache',
          headers: {
            Authorization: 'Bearer ' + this.userAttribute.jwtToken,
          },
        });
        return await this._handleResponse(response);
      } catch (error) {
        return await this._handleTokenRefreshError(error, isRetry, () => this.$fetchDelete(api, query, true));
      }
    },

    async $fetchPost(api, data, isRetry = false) {
      const urlQuery = this.userAttribute.authProvider === 'azuread' ? api : api + '-c';
      try {
        const response = await fetch(this.apiEndpoint + urlQuery, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.userAttribute.jwtToken,
          },
          body: data,
        });
        return await this._handleResponse(response);
      } catch (error) {
        return await this._handleTokenRefreshError(error, isRetry, () => this.$fetchPost(api, data, true));
      }
    },
  },
};
